import SideMenu from "@/layout/SideMenu";
import HeadTitle from "@/layout/HeadTitle";
import {
  SunOutlined,
  TagOutlined,
  FormOutlined,
  ShopOutlined,
  CheckOutlined,
  MobileOutlined,
  SearchOutlined,
  ProfileOutlined,
  FileDoneOutlined,
  SolutionOutlined,
  ExperimentOutlined,
  RadarChartOutlined,
} from "@ant-design/icons";
import plan from "@assets/icons/menuIcons/planicon.svg";
import labIcon from "@assets/icons/menuIcons/labicon.svg";
import experts from "@assets/icons/menuIcons/experts.svg";
import saffron from "@assets/icons/menuIcons/Zafaron.svg";
import invoices from "@assets/icons/menuIcons/financial.svg";
import visitIcon from "@assets/icons/menuIcons/visiticon.svg";
import operation from "@assets/icons/menuIcons/operation.svg";
import harvestIcon from "@assets/icons/menuIcons/harvest.svg";
import planetIcon from "@assets/icons/menuIcons/planeticon.svg";
import cultivarIcon from "@assets/icons/menuIcons/cultivar.svg";
import yieldGap from "@assets/icons/menuIcons/yieldGapIcon.svg";
import marketIcon from "@assets/icons/menuIcons/farmershop.svg";
import sowingdate from "@assets/icons/menuIcons/plantingDate.svg";
import weatherIcon from "@assets/icons/menuIcons/weathericon.svg";
import waterSource from "@assets/icons/menuIcons/waterSource.svg";
import weedlessIcon from "@assets/icons/menuIcons/weedlessicon.svg";
import plantdensity from "@assets/icons/menuIcons/Plantdensity.svg";
import mechanization from "@assets/icons/menuIcons/mechanization.svg";
import croppingpattern from "@assets/icons/menuIcons/croppingpattern.svg";
import financialmanagement from "@assets/icons/menuIcons/financialmanagement.svg";
import croppingsuitability from "@assets/icons/menuIcons/croppingsuitability.svg";
import chillingRequirementIcon from "@assets/icons/menuIcons/chillingrequirement.svg";

export function sideMenuContent(
  pathName,
  id,
  section2,
  products,
  data,
  showHeadTitle,
  showSideMenu
) {
  switch (pathName) {
    case "/my-fields":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={planetIcon}
              products={products}
              data={data}
              section2={section2}
              link={""}
              styleColor={"text-agroyar"}
              title1={"مدیریت زمین"}
              title2={"نکات مهم در مدیریت زمین"}
              hasContact={true}
              content={
                "ثبت زمین شامل اطلاعات عمومی به همراه موقعیت و محدوده زمین است. با تعیین محدوده زمین‌های خود میتوانید خدمات مختلف اگرویار را برای هر کدام از زمین‌هایتان دریافت نمائید. همچنین شما در بلند مدت به تاریخچه ای از اطلاعات زمین خود دسترسی خواهید داشت."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={planetIcon}
              styleColor={"!text-agroyar"}
              title1={"زمین‌های من"}
              content={
                "در این بخش می‌توانید زمین‌های تحت مدیریت خود را مشاهده و ثبت کنید. همچنین، می‌توانید فصل رشدی هر زمین و عملیات انجام‌شده در طول فصل را وارد کنید. از آنجاییکه ثبت اطلاعات و به‌روزرسانی آن بر کیفیت خدمات تأثیر می‌گذارد، لازم است زمین‌ها و هر فصل رشدی به طور صحیح و دقیق ثبت شوند."
              }
            />
          )}{" "}
        </>
      );

    case `/my-fields/field_certificate/${id}`:
      return (
        <>
          <SideMenu
            sourceLogo={planetIcon}
            products={products}
            data={data}
            section2={section2}
            link={""}
            styleColor={"text-agroyar"}
            title1={"شناسنامه زمین"}
            title2={"نکات مهم در مدیریت زمین"}
            hasContact={true}
            content={
              "شناسنامه زمین شامل تمام اطلاعات  ثبت شده توسط شما از زمین در اگرویار می‌باشد. با تعیین محدوده زمین‌های خود و نیز ثبت فصول رشدی هر زمین، میتوانید خدمات مختلف اگرویار را برای هر کدام از زمین‌هایتان دریافت نمائید. همچنین شما در بلند مدت به تاریخچه ای از اطلاعات زمین خود دسترسی خواهید داشت."
            }
          />{" "}
        </>
      );

    case "/my-colleagues":
      return (
        <>
          {" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={experts}
              styleColor={"!text-[#005AC7]"}
              title1={" همکاران من  "}
              content={
                "در این صفحه می‌توانید لیست همکاران، کارشناسان مقیم مزرعه و کارشناسان توصیه‌کننده خود را مشاهده کنید. همچنین می‌توانید به همکاران خود دسترسی دهید و کارشناسان مورد نظر خود را در بخش کارشناسان مقیم مزرعه یا کارشناسان توصیه‌کننده خود، اضافه و مدیریت کنید."
              }
            />
          )}{" "}
        </>
      );

    case "/my-colleaguesCOLLEAGUE_ACCESS":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={experts}
              products={products}
              data={data}
              section2={section2}
              link={""}
              styleColor={"text-[#005AC7]"}
              title1={"همکاران من "}
              hasContact={true}
              content={
                "کاربرانی که در این صفحه اضافه می‌کنید، می‌توانند وارد داشبورد شما شوند و بخش‌هایی که شما به ایشان دسترسی داده‌اید را مشاهده و مدیریت کنند. هر زمان تمایل داشتید می‌توانید کارشناسانی که اضافه کرده‌اید را حذف کرده و یا دسترسی آن‌ها را ویرایش کنید."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={experts}
              styleColor={"!text-[#005AC7]"}
              title1={" همکاران من  "}
              content={
                "در این بخش می‌توانید کاربرانی که تمایل دارید به تمام یا بخشی از اطلاعات داشبورد شما دسترسی داشته باشند را اضافه نمائید."
              }
            />
          )}{" "}
        </>
      );

    case "/my-colleaguesLEADING_EXPERT":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={experts}
              products={products}
              data={data}
              section2={section2}
              link={""}
              styleColor={"text-[#005AC7]"}
              title1={"کارشناسان مقیم مزرعه"}
              hasContact={true}
              content={
                "در این بخش می‌توانید کارشناسانی که در مزرعه شما فعالیت دارند را به عنوان کارشناس مقیم مزرعه معرفی کنید. در صورت انتخاب کارشناس مقیم مزرعه خود برای ماموریت‌ها، هزینه انجام ماموریت خدمات اگرویار از شما دریافت نخواهد شد."
              }
            />
          )}{" "}
        </>
      );

    case "/my-colleaguesRECOMMENDER":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={experts}
              products={products}
              data={data}
              section2={section2}
              link={""}
              styleColor={"text-[#005AC7]"}
              title1={"کارشناسان توصیه‌کننده"}
              hasContact={true}
              content={
                "کارشناسان توصیه‌کننده، راهکارهای تخصصی مورد نیاز مزرعه شما را ارائه می‌دهند. در این بخش می‌توانید درخواست همکاری خود را برای کارشناسان توصیه‌کننده ارسال کرده و آن‌ها را مدیریت کنید."
              }
            />
          )}{" "}
        </>
      );

    case "/my-water-sources":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={waterSource}
              products={products}
              data={data}
              section2={section2}
              link={""}
              styleColor={"text-[#013097]"}
              title1={" مدیریت منابع آبی"}
              title2={"نکات مهم در مدیریت آبی"}
              hasContact={true}
              content={
                "ثبت منابع آبی (چاه، سد، رودخانه، قنات، چشمه، بند خاکی) شامل اطلاعات عمومی به همراه موقعیت آن است. با تعیین خصوصیات و موقعیت جغرافیایی منابع آبی خود میتوانید خدمات مختلف اگرویار را با توجه به خصوصیات آب مزرعه خود دریافت نمائید. "
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={waterSource}
              styleColor={"!text-[#013097]"}
              title1={" منابع آبی من"}
              content={
                "در این بخش می‌توانید منابع آبی باغ و مزارع خود را مشاهده و مدیریت کنید. از آنجاییکه ثبت اطلاعات و به‌روزرسانی آن بر کیفیت خدمات تأثیر می‌گذارد، لازم است منابع آبی باغ و مزرعه به طور صحیح و دقیق ثبت شده باشند."
              }
            />
          )}{" "}
        </>
      );

    case `/my-water-sources/water_certificate/${id}`:
      return (
        <>
          <SideMenu
            sourceLogo={waterSource}
            products={products}
            data={data}
            section2={section2}
            link={""}
            styleColor={"text-[#013097]"}
            title1={" شناسنامه آب"}
            title2={"نکات مهم در مدیریت آبی"}
            hasContact={true}
            content={
              "ثبت منابع آبی (چاه، سد، رودخانه، قنات، چشمه، بند خاکی) شامل اطلاعات عمومی به همراه موقعیت آن است. با تعیین خصوصیات و موقعیت جغرافیایی منابع آبی خود میتوانید خدمات مختلف اگرویار را با توجه به خصوصیات آب مزرعه خود دریافت نمائید. "
            }
          />{" "}
        </>
      );

    case "/discount":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={waterSource}
              products={products}
              data={data}
              section2={section2}
              link={""}
              styleColor={"text-agroyar"}
              title1={"تخفیف ها"}
              title2={"نکات مهم در مدیریت آبی"}
              hasContact={true}
              content={
                "تمام تخفیف هایی که برای شما فعال است در این بخش قابل مشاهده هستند. کد تخفیف مورد نظر خود را کپی کرده و در زمان پرداخت ثبت نمائید."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={waterSource}
              styleColor={"!text-[#013097]"}
              title1={" منابع آبی من"}
              content={
                "در این بخش منابع آبی باغات و مزارع شما قابل مشاهده هستند. جهت افزایش دقت در خدمات دریافتی از پلتفرم اگرویار، لازم است منابع آبی باغ و مزرعه به طور دقیق ثبت شده باشند. دقت در ثبت اطلاعات و بروزرسانی آن ارتباط مستقیمی با کیفیت ارائه خدمات دارد."
              }
            />
          )}{" "}
        </>
      );

    case "/weather-station":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={weatherIcon}
              products={products}
              data={data}
              section2={section2}
              link={""}
              styleColor={"text-agroyar"}
              title1={"ایستگاه هواشناسی مجازی چیست؟"}
              title2={"راهنمای ثبت ایستگاه هواشناسی"}
              hasContact={true}
              content={
                "ایستگاه هواشناسی مجازی رباتی است که اطلاعات آب و هوایی و اقلیمی نقطه GPS مورد نظر شما را با استفاده از اطلاعات ماهواره ای و ایستگاه‌های هواشناسی منطقه جمع‌آوری کرده و پس از تحلیل در اختیار شما قرار می‌دهد. این اطلاعات، اختصاصی برای کشاورزی تحلیل می‌شوند و ممکن است با هواشناسی محیط شهری کمی متفاوت باشد. با فعال بودن ایستگاه در محدوده زمین‌های کشاورزی شما، تمام خدمات اگرویار با توجه به اطلاعات اقلیمی و آب و هوایی همان نقطه GPS ارائه می‌شود."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={weatherIcon}
              styleColor={"!text-agroyar"}
              title1={"ایستگاه هواشناسی مجازی"}
              content={
                <p>
                  امکانات ایستگاه هواشناسی مجازی اگرویار:
                  <br /> ۱.اطلاع لحظه‌ای از آب و هوای منطقه مورد نظر <br />{" "}
                  ۲.پیش‌بینی آب و هوا تا۱۶ روز آینده <br />
                  3. هشدارهای هواشناسی کشاورزی و پیش‌آگاهی از اقدامات لازم در
                  شرایط گرما، سرما، باران، برف و طوفان <br /> ۴.اطلاعات اقلیمی
                  30 ساله منطقه برای تعیین تاریخ کاشت، زمان برداشت، نیاز سرمایی
                  و سایر خدمات اگرویار{" "}
                </p>
              }
            />
          )}{" "}
        </>
      );

    case "/nutrition-program":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={plan}
              section2={section2}
              styleColor={"!text-[#00817A]"}
              link={"https://blog.agroyaar.com/nutplan/"}
              title1={"برنامه کودی چیست؟"}
              title2={"معرفی سامانه برنامه کودی"}
              hasContact={true}
              content={
                "برنامه کودی یا برنامه کوددهی، یک لیست از تمام کارهایی است که برای تغذیه باغ و مزرعه باید انجام گیرد و بر چهار اصل مهم نوع کود مناسب، مقدار مناسب، زمان و روش درست مصرف کود پایه‌گذاری شده است. استفاده از برنامه کودی باعث مدیریت اصولی تغذیه و کوددهی، مدیریت هزینه‌ها و افزایش راندمان تولید می‌شود."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={plan}
              styleColor={"!text-[#00817A]"}
              link={""}
              title1={"پرسشنامه و برنامه‌کودی‌ها"}
              content={
                "لیست تمام درخواست‌ها و فایل‌ برنامه کودی‌های شما در این صفحه قابل مشاهده هستند. برنامه کودی اختصاصا برای کشاورزی شما نگارش شده و فقط در مزرعه یا باغ شما قابل استفاده است. برای دستیابی به عملکرد مطلوب پیشنهاد می‌شود برنامه کودی را با دقت و به طور کامل اجرا کنید."
              }
            />
          )}{" "}
        </>
      );

    case "/visit":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={visitIcon}
              products={products}
              data={data}
              section2={section2}
              styleColor={"!text-visit"}
              link={"https://help.agroyaar.com/agrovisit/"}
              title1={"مراحل بازدید و نظارت اگرویار"}
              title2={"راهنمای سامانه بازدید"}
              hasContact={true}
              hasSteps={true}
              items={[
                {
                  title: "درخواست بازدید و نظارت",
                  description: "مرحله 1",
                  status: "finish",
                  icon: (
                    <SearchOutlined
                      className={`font-extrabold !text-visit `}
                    />
                  ),
                },
                {
                  title: "حضور کارشناس راهبر در موقعیت باغ و مزرعه",
                  description: "مرحله 2",
                  status: "finish",
                  icon: (
                    <SolutionOutlined
                      className={`font-extrabold !text-visit `}
                    />
                  ),
                },
                {
                  title: "ثبت اطلاعات و مشاهدات در اپلیکیشن اگرویار",
                  description: "مرحله 3",
                  status: "finish",
                  icon: (
                    <MobileOutlined
                      className={`font-extrabold !text-visit `}
                    />
                  ),
                },
                {
                  title: "پردازش اطلاعات و ترسیم نقشه‌های ارزیابی",
                  description: "مرحله 4",
                  status: "finish",
                  icon: (
                    <RadarChartOutlined
                      className={`font-extrabold !text-visit `}
                    />
                  ),
                },
                {
                  title: "ارائه گزارش و توصیه‌های فنی",
                  description: "مرحله 5",
                  status: "finish",
                  icon: (
                    <FileDoneOutlined
                      className={`font-extrabold !text-visit `}
                    />
                  ),
                },
              ]}
              content={""}
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={visitIcon}
              styleColor={"!text-visit"}
              styleButton={"!visit-button"}
              link={"/visit-reports"}
              buttontext={"لیست گزارشات و توصیه‌ها "}
              title1={"درخواست‌های بازدید و نظارت"}
              content={
                "در مدیریت مزرعه، کنترل آفات و بیماری‌ها، علف‌های هرز و اجرای اصولی عملیات کاشت، داشت و برداشت از اهمیت ویژه‌ای برخوردار است. اگرویار با ارائه ابزارهایی برای ثبت دقیق اطلاعات و نظارت هوشمندانه بر این فرآیندها، به شما جهت آگاهی بیشتر از وضعیت، برنامه‌ریزی و مدیریت اصولی کمک می‌کند."
              }
            />
          )}{" "}
        </>
      );

    case "/visit-reports":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={visitIcon}
              products={products}
              data={data}
              section2={section2}
              styleColor={"!text-visit"}
              link={"https://blog.agroyaar.com/visit/"}
              title1={"سامانه بازدید اگرویار"}
              title2={"معرفی سامانه بازدید"}
              hasContact={true}
              hasSteps={false}
              content={
                <p className="max-lg:w-full text-right text-xs">
                  1. حضور کارشناس در موقعیت زمین <br />
                  2. ثبت اطلاعات در اپلیکیشن اگرویار <br />
                  3. تحلیل و بررسی مشکلات موجود <br />
                  4. ارائه گزارش تخصصی <br />
                  5. پشتیبانی و ارائه پیش آگاهی‌ها{" "}
                </p>
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={visitIcon}
              styleColor={"!text-visit"}
              styleButton={"!visit-button"}
              link={"/visit"}
              buttontext={"لیست درخواست‌ها "}
              title1={"گزارشات و توصیه‌های بازدید و نظارت"}
              content={
                "لیست تمام گزارشات بازدید و نظارت زمین‌های شما در این صفحه قابل مشاهده هستند. همچنین اگر در هنگام ثبت درخواست جهت دریافت توصیه‌های لازم اقدام کرده باشید، توصیه‌های لازم به همراه فایل گزارش برای شما قابل ارائه خواهد بود."
              }
            />
          )}{" "}
        </>
      );

    case "/operations":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={operation}
              products={products}
              data={data}
              section2={section2}
              styleColor={"!text-president"}
              link={""}
              title1={"مدیریت عملیات در مزرعه"}
              title2={"معرفی سامانه عملیات"}
              hasContact={true}
              hasSteps={true}
              items={[
                {
                  title: "درخواست انجام عملیات",
                  description: "مرحله 1",
                  status: "finish",
                  icon: (
                    <SearchOutlined
                      className={`font-extrabold !text-president `}
                    />
                  ),
                },
                {
                  title: "پردازش درخواست و تعیین کارشناس مرتبط",
                  description: "مرحله 2",
                  status: "finish",
                  icon: (
                    <SolutionOutlined
                      className={`font-extrabold !text-president `}
                    />
                  ),
                },
                {
                  title: "انجام عملیات توسط کارشناس",
                  description: "مرحله 3",
                  status: "finish",
                  icon: (
                    <MobileOutlined
                      className={`font-extrabold !text-president `}
                    />
                  ),
                },
                {
                  title: "ارائه گزارش مطابق با نوع عملیات شما",
                  description: "مرحله 4",
                  status: "finish",
                  icon: (
                    <FileDoneOutlined
                      className={`font-extrabold !text-president `}
                    />
                  ),
                },
              ]}
              content={""}
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={operation}
              styleColor={"!text-president"}
              styleButton={"!chilling-button"}
              link={"/operations"}
              buttontext={"لیست گزارشات و توصیه‌ها "}
              title1={"درخواست‌های عملیات"}
              content={
                "در بخش عملیات، امکان ثبت درخواست برای انجام امور فنی و پیگیری صحیح امور اجرایی مزرعه فراهم شده است. این بخش با هدف کاهش چالش‌ها و تسریع فرآیندها، به شما در مدیریت امور فنی و اجرایی کمک می‌کند."
              }
            />
          )}{" "}
        </>
      );

    case "/laboratory":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={labIcon}
              products={products}
              data={data}
              section2={section2}
              link={"https://help.agroyaar.com/agrolab/"}
              styleColor={"text-lab"}
              title1={"آزمایشگاه جامع اگرویار"}
              title2={"راهنمای آزمایشگاه اگرویار"}
              hasContact={true}
              hasSteps={true}
              items={[
                {
                  title: "درخواست آزمایش",
                  description: "مرحله 1",
                  status: "finish",
                  icon: (
                    <SearchOutlined
                      className={`font-extrabold !text-lab `}
                    />
                  ),
                },
                {
                  title: "حضور کارشناس راهبر جهت نمونه‌برداری",
                  description: "مرحله 2",
                  status: "finish",
                  icon: (
                    <SolutionOutlined
                      className={`font-extrabold !text-lab `}
                    />
                  ),
                },
                {
                  title: "ثبت نقاط GPS و کد نمونه‌ها در اپلیکیشن اگرویار",
                  description: "مرحله 3",
                  status: "finish",
                  icon: (
                    <MobileOutlined
                      className={`font-extrabold !text-lab `}
                    />
                  ),
                },
                {
                  title: "آنالیز نمونه‌ها توسط آزمایشگاه تخصصی",
                  description: "مرحله 4",
                  status: "finish",
                  icon: (
                    <ExperimentOutlined
                      className={`font-extrabold !text-lab `}
                    />
                  ),
                },
                {
                  title: "ارائه نتایج، نقشه‌ها و توصیه‌های فنی",
                  description: "مرحله 5",
                  status: "finish",
                  icon: (
                    <FileDoneOutlined
                      className={`font-extrabold !text-lab `}
                    />
                  ),
                },
              ]}
              content={""}
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={labIcon}
              styleColor={"!text-lab"}
              styleButton={"!laboratory-button"}
              link={"/laboratory-reports"}
              buttontext={"لیست گزارشات و نتایج "}
              title1={"درخواست‌های آزمایش"}
              content={
                "در بخش درخواست آزمایشگاه اگرویار، امکان ثبت درخواست برای نمونه‌برداری و انجام آزمایش‌های تخصصی آب، خاک، گیاه، محصول نهایی، کود و بیماری شناسی گیاهی فراهم شده است. این آزمایش‌ها به‌عنوان یکی از اقدامات مدیریتی، به شما در ارزیابی شرایط، تشخیص مشکلات احتمالی و بررسی کیفیت کود و محصولات کمک می‌کنند."
              }
            />
          )}{" "}
        </>
      );

    case "/laboratory-reports":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={labIcon}
              products={products}
              data={data}
              section2={section2}
              link={"https://lab.agroyaar.com/"}
              styleColor={"text-lab"}
              title1={"آزمایشگاه جامع اگرویار"}
              title2={"معرفی آزمایشگاه اگرویار"}
              hasContact={true}
              content={
                "در بخش درخواست آزمایشگاه اگرویار، امکان ثبت درخواست برای نمونه‌برداری و انجام آزمایش‌های تخصصی آب، خاک، گیاه، محصول نهایی، کود و بیماری شناسی گیاهی فراهم شده است. این آزمایش‌ها به‌عنوان یکی از اقدامات مدیریتی، به شما در ارزیابی شرایط، تشخیص مشکلات احتمالی و بررسی کیفیت کود و محصولات کمک می‌کنند."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={labIcon}
              styleColor={"!text-lab"}
              styleButton={"!laboratory-button"}
              link={"/laboratory"}
              buttontext={"لیست درخواست‌ها "}
              title1={"گزارشات و درخواست‌های آزمایش"}
              content={
                "لیست تمام درخواست‌ها و فایل نتایج آزمایشات شما در این صفحه قابل مشاهده هستند. نتایج آزمایشات شما در ارائه خدمات برنامه کودی، تاریخ کاشت، پتانسیل عملکرد و ... مورد بررسی و تحلیل قرار می‌گیرد."
              }
            />
          )}{" "}
        </>
      );

    case "/chilling-requirement":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={chillingRequirementIcon}
              products={products}
              data={data}
              section2={section2}
              link={
                "https://help.agroyaar.com/chilling-requirements-for-trees/"
              }
              styleColor={"text-[#491086]"}
              title1={"نیاز سرمایی چیست؟"}
              title2={"راهنمای تعیین نیاز سرمایی"}
              hasContact={true}
              content={
                "به تعداد ساعت‌های سرمایی موثر که برای رشد مجدد جوانه‌ها در فصل رشد نیاز است، نیاز سرمایی درختان گفته می‌شود. این ساعت‌ها بسته به نوع و رقم درخت متفاوت است. در این بخش میتوانید تامین نیاز سرمایی درختان را بسته به اطلاعات اقلیمی و آب و هوایی محدوده زمین‌های خودتان بررسی کنید."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={chillingRequirementIcon}
              styleColor={"!text-[#491086]"}
              link={""}
              title1={"سامانه تعیین نیاز سرمایی"}
              content={
                <p>
                  در این بخش میتوانید تامین نیاز سرمایی درختان را بسته به
                  اطلاعات اقلیمی و آب و هوایی محدوده زمین‌های خودتان بررسی کنید.{" "}
                  <br />
                  در حال حاضر سامانه تعیین نیاز سرمایی{" "}
                  <span className="text-[#491086] font-extrabold">
                    تنها برای کشت پسته{" "}
                  </span>{" "}
                  فعال است.{" "}
                </p>
              }
            />
          )}{" "}
        </>
      );

    case `/chilling-requirement/${id}`:
      return (
        <SideMenu
          sourceLogo={chillingRequirementIcon}
          products={products}
          data={data}
          section2={section2}
          link={""}
          styleColor={"text-[#491086]"}
          title1={"تعیین نیاز سرمایی"}
          title2={"راهنمای ثبت درخواست"}
          hasContact={true}
          content={
            "به تعداد ساعت‌های سرمایی موثر که برای رشد مجدد جوانه‌ها در فصل رشد نیاز است، نیاز سرمایی درختان گفته می‌شود. این ساعت‌ها بسته به نوع و رقم درخت متفاوت است. در این بخش میتوانید تامین نیاز سرمایی درختان را بسته به اطلاعات اقلیمی و آب و هوایی محدوده زمین‌های خودتان بررسی کنید."
          }
        />
      );

    case "/cultivar-recommendation":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={cultivarIcon}
              link={"https://help.agroyaar.com/choose-crop-cultivar/"}
              styleColor={"text-[#491086]"}
              title1={"انتخاب رقم مناسب"}
              title2={"شناخت سامانه انتخاب رقم "}
              hasContact={true}
              content={
                "بذر گیاهان زراعی و باغی ارقام متنوعی داشته که هر کدام بسته به خصوصیاتی که دارند در مناطق و شرایط مختلفی باید کشت شوند. این سامانه به شما کمک می‌کند تا مناسبترین رقم را با توجه به خصوصیات منطقه و شرایط مدنظر خودتان انتخاب نمائید."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={cultivarIcon}
              products={products}
              section2={section2}
              data={data}
              styleColor={"!text-[#491086]"}
              link={""}
              title1={"سامانه انتخاب رقم مناسب"}
              content={
                "در این بخش مناسب‌ترین ارقام برای کاشت را بسته به شرایط اختصاصی و اطلاعات اقلیمی و آب و هوایی محدوده زمین‌های خودتان دریافت کنید."
              }
            />
          )}{" "}
        </>
      );

    case `/cultivar-recommendation/${id}`:
      return (
        <SideMenu
          sourceLogo={cultivarIcon}
          products={products}
          data={data}
          link={"#"}
          section2={section2}
          styleColor={"text-[#491086]"}
          title1={"انتخاب رقم مناسب"}
          title2={"راهنمای ثبت درخواست"}
          hasContact={true}
          content={
            "بذر گیاهان زراعی و باغی ارقام متنوعی داشته که هر کدام بسته به خصوصیاتی که دارند در مناطق و شرایط مختلفی باید کشت شوند. این سامانه به شما کمک می‌کند تا مناسبترین رقم را با توجه به خصوصیات منطقه و شرایط مدنظر خودتان انتخاب نمائید."
          }
        />
      );

    case "/harvest-recommendation":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={harvestIcon}
              link={"https://help.agroyaar.com/harvest-time/"}
              styleColor={"text-[#491086]"}
              title1={"تعیین تاریخ برداشت"}
              title2={"راهنمای تعیین تاریخ برداشت"}
              hasContact={true}
              content={
                "برداشت زودهنگام یا دیرهنگام محصول میتواند منجر به ضررهای مالی فراوانی شود. از ارائه محصول به بازار گرفته تا مشکلات انبارمانی، ریزش بذر قبل برداشت، میوه‌های نارس، کاهش کیفیت محصولات و ... مربوط به عدم آگاهی از تاریخ درست برداشت است."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={harvestIcon}
              products={products}
              data={data}
              section2={section2}
              styleColor={"!text-[#491086]"}
              link={""}
              title1={"سامانه تعیین تاریخ برداشت"}
              content={
                "در این بخش میتوانید تاریخ برداشت محصول خود را با توجه به شرایط اقلیمی و آب و هوایی زمین‌تان تخمین بزنید."
              }
            />
          )}{" "}
        </>
      );

    case `/harvest-recommendation/${id}`:
      return (
        <SideMenu
          sourceLogo={harvestIcon}
          products={products}
          data={data}
          link={"#"}
          section2={section2}
          styleColor={"text-[#491086]"}
          title1={"تعیین تاریخ برداشت"}
          title2={"راهنمای ثبت درخواست"}
          hasContact={true}
          content={
            "برداشت زودهنگام یا دیرهنگام محصول میتواند منجر به ضررهای مالی فراوانی شود. از ارائه محصول به بازار گرفته تا مشکلات انبارمانی، ریزش بذر قبل برداشت، میوه‌های نارس، کاهش کیفیت محصولات و ... مربوط به عدم آگاهی از تاریخ درست برداشت است."
          }
        />
      );

    case "/sowing-date":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={planetIcon}
              products={products}
              data={data}
              section2={section2}
              link={"https://help.agroyaar.com/optimal-planting-date/"}
              styleColor={"text-[#491086]"}
              title1={"تعیین تاریخ کاشت"}
              title2={"راهنمای تعیین تاریخ کاشت"}
              hasContact={true}
              content={
                "تعیین تاریخ کاشت مناسب برای یک محصول زراعی، امری حیاتی است که تأثیر مستقیمی بر عملکرد و کیفیت نهایی آن دارد. برای این منظور، عوامل مختلفی از جمله شرایط آب و هوایی منطقه، نوع محصول، و نیازهای خاص هر گیاه باید در نظر گرفته شوند. "
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={sowingdate}
              styleColor={"!text-[#491086]"}
              title1={"تعیین تاریخ کاشت"}
              content={
                "انتخاب تاریخ کاشت بهینه می‌تواند منجر به افزایش قابل توجه عملکرد، بهره‌وری محصول، بهبود کیفیت و کاهش خسارات شود."
              }
            />
          )}{" "}
        </>
      );

    case "/weed-management/public-prescription":
      return (
        <SideMenu
          sourceLogo={weedlessIcon}
          products={products}
          data={data}
          section2={section2}
          link={"https://visit.agroyaar.com/visitRequest"}
          styleColor={"!text-weedless"}
          title1={"مدیریت علف هرز"}
          title2={"نکات مهم در مورد مدیریت علف‌های هرز"}
          hasContact={true}
          content={
            "سامانه مدیریت علف‌های هرز یک راهکار ارائه شده برای دستیابی به عملکرد مطلوب در ریشه کنی علف‌های هرز مزرعه شما ارائه شده است. نسخه دریافتی را با دقت و به طور کامل اجرا کنید. در صورت نیاز به راهنمایی و یا مشاوره، می‌توانید با کارشناسان تیم پشتیبانی تماس بگیرید."
          }
        />
      );

    case "/weed-management":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={weedlessIcon}
              products={products}
              data={data}
              section2={section2}
              link={""}
              styleColor={"!text-weedless"}
              title1={"مدیریت علف هرز"}
              title2={"راهنمای سامانه مدیریت علف‌های هرز"}
              hasContact={true}
              content={
                "سامانه مدیریت علف‌های هرز یک راهکار ارائه شده برای دستیابی به عملکرد مطلوب در ریشه کنی علف‌های هرز مزرعه شما ارائه شده است. نسخه دریافتی را با دقت و به طور کامل اجرا کنید. در صورت نیاز به راهنمایی و یا مشاوره، می‌توانید با کارشناسان تیم پشتیبانی تماس بگیرید."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={weedlessIcon}
              data={data}
              styleColor={"!text-weedless"}
              link={""}
              title1={"گزارشات و درخواست‌های مدیریت علف هرز"}
              content={
                "سامانه تخصصی مدیریت علف هرز جهت کنترل میزان علف‌های هرز مزرعه شما ایجاد گشته است. جهت درخواست نسخه عمومی مدیریت علف‌های هرز میتوانید درخواست خود را ثبت کنید."
              }
            />
          )}{" "}
        </>
      );

    case "/cropping-pattern":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={croppingpattern}
              products={products}
              data={data}
              section2={section2}
              // link={"https://help.agroyaar.com/agrolab/"}
              styleColor={"text-[#491086]"}
              title1={"مراحل دریافت الگوی کشت"}
              title2={"راهنمای الگوی کشت"}
              hasContact={true}
              hasSteps={true}
              items={[
                {
                  title: "ایجاد درخواست جدید",
                  description: "مرحله 1",
                  status: "finish",
                  icon: (
                    <FormOutlined 
                      className={`font-extrabold !text-[#491086] `}
                    />
                  ),
                },
                {
                  title: "انتخاب روش تناسب کشت",
                  description: "مرحله 2",
                  status: "finish",
                  icon: (
                    <CheckOutlined
                      className={`font-extrabold !text-[#491086] `}
                    />
                  ),
                },
                {
                  title: "تعیین زمین، منبع آبی و ایستگاه هواشناسی",
                  description: "مرحله 3",
                  status: "finish",
                  icon: (
                    <SunOutlined
                      className={`font-extrabold !text-[#491086] `}
                    />
                  ),
                },
                {
                  title: "انتخاب آزمایش خاک",
                  description: "مرحله 4",
                  status: "finish",
                  icon: (
                    <ExperimentOutlined
                      className={`font-extrabold !text-[#491086] `}
                    />
                  ),
                },
                {
                  title: "تکمیل پرسشنامه",
                  description: "مرحله 5",
                  status: "finish",
                  icon: (
                    <SolutionOutlined
                      className={`font-extrabold !text-[#491086] `}
                    />
                  ),
                },
                {
                  title: "پرداخت و دریافت گزارش",
                  description: "مرحله 6",
                  status: "finish",
                  icon: (
                    <FileDoneOutlined
                      className={`font-extrabold !text-[#491086] `}
                    />
                  ),
                },
              ]}
              content={""}
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={croppingpattern}
              styleColor={"!text-[#491086]"}
              styleButton={"!cropping-pattern"}
              title1={"الگوی کشت"}
              content={
                "سامانه الگوی کشت به شما کمک می‌کند تا با توجه به ویژگی‌های زمین، منابع آب، شرایط اقلیمی و ...، محصول و سطح زیرکشت مناسب آن را انتخاب کنید. در این بخش می‌توانید درخواست خود را برای تعیین الگوی کشت ثبت کنید و لیست گزارشات الگوی کشت زمین‌های خود را مشاهده کنید."
              }
            />
          )}{" "}
        </>
      );

    case "/cropping-suitability":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={croppingsuitability}
              products={products}
              data={data}
              section2={section2}
              link={"https://help.agroyaar.com/agrolab/"}
              styleColor={"text-[#491086]"}
              title1={"مراحل دریافت تناسب کشت"}
              title2={"راهنمای تناسب کشت"}
              hasContact={true}
              hasSteps={true}
              items={[
                {
                  title: "ایجاد درخواست جدید",
                  description: "مرحله 1",
                  status: "finish",
                  icon: (
                    <FormOutlined 
                      className={`font-extrabold !text-[#491086] `}
                    />
                  ),
                },
                {
                  title: "انتخاب روش تناسب کشت",
                  description: "مرحله 2",
                  status: "finish",
                  icon: (
                    <CheckOutlined
                      className={`font-extrabold !text-[#491086] `}
                    />
                  ),
                },
                {
                  title: "تعیین زمین، منبع آبی و ایستگاه هواشناسی",
                  description: "مرحله 3",
                  status: "finish",
                  icon: (
                    <SunOutlined
                      className={`font-extrabold !text-[#491086] `}
                    />
                  ),
                },
                {
                  title: "انتخاب آزمایش خاک",
                  description: "مرحله 4",
                  status: "finish",
                  icon: (
                    <ExperimentOutlined
                      className={`font-extrabold !text-[#491086] `}
                    />
                  ),
                },
                {
                  title: "تکمیل پرسشنامه",
                  description: "مرحله 5",
                  status: "finish",
                  icon: (
                    <SolutionOutlined
                      className={`font-extrabold !text-[#491086] `}
                    />
                  ),
                },
                {
                  title: "پرداخت و دریافت گزارش",
                  description: "مرحله 6",
                  status: "finish",
                  icon: (
                    <FileDoneOutlined
                      className={`font-extrabold !text-[#491086] `}
                    />
                  ),
                },
              ]}
              content={""}
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={croppingsuitability}
              styleColor={"!text-[#491086]"}
              styleButton={"!cropping-pattern"}
              title1={"تناسب کشت"}
              content={
                "سامانه تناسب کشت به شما کمک می کند تا‌‌ با توجه به ویژگی های خاک، منابع آب و شرایط اقلیمی و ...،میزان سازگاری زمین خود را با محصول یا محصولات مورد نظر خود بررسی کنید .در این بخش می توانید درخواست خود را برای بررسی تناسب کشت ثبت کنید و لیست گزارشات تناسب کشت زمین های خود را مشاهده کنید."
              }
            />
          )}{" "}
        </>
      );

    case "/financial-management/increase-balance":
      return (
        <>
          {" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={financialmanagement}
              styleColor={"text-[#008F47]"}
              title1={"افزایش موجودی کیف پول"}
              content={
                <p>
                  امکان افزایش اعتبار کیف پول با استفاده از کارت‌های بانکی و در
                  شرایطی پرداخت چکی نیز برای شما فراهم آمده است.{" "}
                </p>
              }
            />
          )}{" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={financialmanagement}
              link={""}
              styleColor={"text-[#008F47]"}
              title1={"انتخاب شیوه پرداخت"}
              title2={"سوابق پرداختی و فاکتورها"}
              hasContact={false}
              content={
                "لطفا بنابه شرایط خود، شیوه پرداخت مناسب را انتخاب نمایید."
              }
            />
          )}{" "}
        </>
      );

    case "/financial-management":
      return (
        <>
          {" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={financialmanagement}
              styleColor={"text-[#008F47]"}
              title1={"مدیریت مالی"}
              content={
                <p>
                  مدیریت ساده و مؤثر امور مالی در داشبورد کشاورزی شما در این بخش
                  در دسترس می‌باشد.شما میتوانید در این بخش به سوابق پرداختی،
                  فاکتورها و تخفیف‌های خود دسترسی داشته باشید.همچنین می‌توانید
                  کیف پول خود را شارژ کرده و تراکنش‌های کیف پول خود را پیگیری
                  کنید.{" "}
                </p>
              }
            />
          )}{" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={financialmanagement}
              link={""}
              styleColor={"text-[#008F47]"}
              title1={"سوابق پرداختی و فاکتورها"}
              title2={"سوابق پرداختی و فاکتورها"}
              hasContact={false}
              content={
                "سابقه مالی شما بصورت کامل در این بخش قابل مشاهده می‌باشد."
              }
            />
          )}{" "}
        </>
      );

    case `/payment/${id}`:
      return (
        <SideMenu
          sourceLogo={invoices}
          link={""}
          styleColor={"text-[#008F47]"}
          title1={"پرداخت"}
          title2={"سوابق پرداختی و فاکتورها"}
          hasContact={false}
          content={
            "پرداخت خود را نهایی کنید. در صورتی که کد تخفیف دارید،آن را در بخش مربوطه ثبت نمایید."
          }
        />
      );

    case "/first-saffron-irrigation":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={chillingRequirementIcon}
              products={products}
              data={data}
              section2={section2}
              styleColor={"text-[#491086]"}
              link={"https://help.agroyaar.com/first-saffron-irrigation/"}
              title1={
                <p className="text-sm tracking-tighter whitespace-nowrap">
                  اهمیت تاریخ آبیاری اول زعفران{" "}
                </p>
              }
              title2={" معرفی سامانه ابیاری اول زعفران"}
              hasContact={false}
              content={
                "در نیمه اول تابستان، گل انگیزی درون بنه‌ها اتفاق می‌افتد، اما برای ظهور گل‌های زعفران باید به بنه‌ها شوک دمایی یا سرما وارد شود که با آبیاری اول زعفران (بسار آب) می‌توانید این شرایط دمایی سرد را برای پیازها فراهم کنید. درصورتیکه آبیاری اول زعفران در زمان درست انجام نشود گیاه به‌جای تحریک به ظهور گل به سمت تحریک رشد رویشی (برگ‌ها) می‌رود که متاسفانه این اتفاق، عملکرد گل‌را به شدت کاهش خواهد داد."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={saffron}
              styleColor={"!text-[#491086]"}
              title1={"تعیین زمان آبیاری اول زعفران"}
              content={
                <p>
                  از طریق سامانه تعیین زمان آبیاری اول زعفران می‌توانید جهت
                  دریافت بهترین زمان برای آبیاری اول زعفران و دریافت گزارش تعیین
                  تاریخ آبیاری زعفران با توجه به اطلاعات اقلیمی مزرعه خود اقدام
                  نمایید.بدیهی است که این سامانه تنها برای کشت زعفران و فصل رشدی
                  حال و آینده قابل استفاده می‌باشد.{" "}
                </p>
              }
            />
          )}{" "}
        </>
      );

    case "/yield-gaps":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={yieldGap}
              products={products}
              data={data}
              section2={section2}
              link={"https://help.agroyaar.com/yield-gap-analysis/"}
              styleColor={"text-[#491086]"}
              title1={" خلأ عملکرد چیست؟"}
              title2={" راهنمای سامانه  خلأ عملکرد"}
              hasContact={true}
              content={
                "به فاصله بین عملکرد واقعی با پتانسیل عملکرد، خلاء عملکرد (شکاف عملکرد) گفته می‌شود. در واقع، این فاصله به ما نشان می‌دهد چه مقدار تولید کرده‌ایم و چه ظرفیتی برای تولید داشته‌ایم."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={yieldGap}
              styleColor={"!text-[#491086]"}
              title1={"خلأ عملکرد"}
              content={
                <p>
                  در این بخش می‌توانید خلأ عملکرد مزرعه و باغات خود را بسته به
                  اطلاعات اقلیمی و آب و هوایی محدوده زمین‌های خودتان بدست
                  آورید.·دقت داشته باشید عوامل مدیریتی و محیطی زیادی برای رسیدن
                  به عملکرد مطلوب نقش دارند.مدیریت تمامی فاکتورهای خلاء عملکرد
                  در کنار هم می‌تواند شما را به عملکرد مطلوب نزدیک کند.{" "}
                </p>
              }
            />
          )}{" "}
        </>
      );

    case "/plant-density":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={plantdensity}
              products={products}
              data={data}
              section2={section2}
              link={"#"}
              styleColor={"text-[#491086]"}
              title1={" تعیین تراکم بوته چیست؟"}
              title2={" معرفی سامانه  خلأ عملکرد"}
              hasContact={true}
              content={
                "به فاصله بین عملکرد واقعی با پتانسیل عملکرد، خلاء عملکرد (شکاف عملکرد) گفته می‌شود. در واقع، این فاصله به ما نشان می‌دهد چه مقدار تولید کرده‌ایم و چه ظرفیتی برای تولید داشته‌ایم."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={plantdensity}
              styleColor={"!text-[#491086]"}
              title1={"تعیین تراکم بوته و میزان بذر مصرفی"}
              content={
                <p>
                  در این بخش می‌توانید خلأ عملکرد مزرعه و باغات خود را بسته به
                  اطلاعات اقلیمی و آب و هوایی محدوده زمین‌های خودتان بدست
                  آورید.·دقت داشته باشید عوامل مدیریتی و محیطی زیادی برای رسیدن
                  به عملکرد مطلوب نقش دارند.مدیریت تمامی فاکتورهای خلاء عملکرد
                  در کنار هم می‌تواند شما را به عملکرد مطلوب نزدیک کند.{" "}
                </p>
              }
            />
          )}{" "}
        </>
      );

    case "/agricultural-market":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={marketIcon}
              products={products}
              data={data}
              section2={section2}
              link={"https://help.agroyaar.com/"}
              styleColor={"text-agroyar"}
              title1={"مراحل خرید نهاده"}
              title2={"راهنمای بازار کشاورزی"}
              hasContact={true}
              hasSteps={true}
              items={[
                {
                  title: "ثبت درخواست خرید نهاده",
                  description: "مرحله 1",
                  status: "finish",
                  icon: (
                    <FileDoneOutlined
                      className={`font-extrabold !text-agroyar `}
                    />
                  ),
                },
                {
                  title: "ارسال درخواست به تامین‌کنندگان",
                  description: "مرحله 2",
                  status: "finish",
                  icon: (
                    <SolutionOutlined
                      className={`font-extrabold !text-agroyar `}
                    />
                  ),
                },
                {
                  title: "ارائه پیشنهاد توسط تامین‌کنندگان",
                  description: "مرحله 3",
                  status: "finish",
                  icon: (
                    <MobileOutlined
                      className={`font-extrabold !text-agroyar `}
                    />
                  ),
                },
                {
                  title: "دریافت پیشنهادات در داشبورد کشاورز",
                  description: "مرحله 4",
                  status: "finish",
                  icon: (
                    <ProfileOutlined
                      className={`font-extrabold !text-agroyar `}
                    />
                  ),
                },
                {
                  title: "بررسی، مقایسه و انتخاب نهاده",
                  description: "مرحله 5",
                  status: "finish",
                  icon: (
                    <TagOutlined
                      className={`font-extrabold !text-agroyar `}
                    />
                  ),
                },
                {
                  title: "تکمیل فرآیند خرید توسط اگرویار",
                  description: "مرحله 6",
                  status: "finish",
                  icon: (
                    <ShopOutlined
                      className={`font-extrabold !text-agroyar `}
                    />
                  ),
                },
              ]}
              content={""}
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={marketIcon}
              styleColor={"!text-agroyar"}
              title1={"بازار کشاورزی"}
              content={
                " بازار کشاورزی یک پلتفرم آنلاین است که به منظور فراهم‌کردن بستری برای خرید نهاده‌های کشاورزی و فروش محصولات کشاورز طراحی شده است. در این سامانه کشاورزان می‌توانند نهاده‌های با کیفیت و با قیمت مناسب را از بازار تامین کرده و محصولات تولیدی خود را در بهترین بازار به فروش برسانند."
              }
            />
          )}{" "}
        </>
      );

    case "/mechanization":
      return (
        <>
          {" "}
          {showSideMenu && (
            <SideMenu
              sourceLogo={mechanization}
              products={products}
              data={data}
              section2={section2}
              styleColor={"text-agroyar"}
              title1={"مدیریت مکانیزاسیون"}
              hasContact={true}
              content={
                "مکانیزاسیون خود را همراه با تصویر و اطلاعات هر کدام ثبت کنید. تغییراتی مانند تعمیرات، تعویض قطعات و سایر  اقدامات نگهداری را به روزرسانی کنید و از وضعیت مکانیزاسیون خود آگاه باشید. همچنین، با فعال سازی خدمات  مانیتورینگ مبتنی بر اینترنت اشیا، امکان نظارت لحظه‌ای بر عملکرد مکانیزاسیون موتوری خود را خواهید داشت."
              }
            />
          )}{" "}
          {showHeadTitle && (
            <HeadTitle
              sourceLogo={mechanization}
              styleColor={"!text-agroyar"}
              title1={"مکانیزاسیون من"}
              content={
                "در این بخش می‌توانید لیست مکانیزاسیون خود را مشاهده و مدیریت کنید. همچنین، می‌توانید عملکرد مکانیزاسیون  موتوری خود را با فعال سازی خدمات مانیتورینگ، به صورت دقیق و لحظه ای زیر نظر بگیرید."
              }
            />
          )}{" "}
        </>
      );

    default:
      return "";
  }
}
